import { ENTITY_TYPES } from '@sales-center/common'
import * as React from 'react'
import Divider from '@mui/material/Divider'
import { ILeadOppProduct } from '@user/store/leadOppProducts'
import { IServiceFrequency } from '@user/store/serviceFrequency'
import { ServiceListCard, ServiceListCardContent } from './styled'
import { ServiceCheckbox } from './ServiceCheckbox'

type Props = {
  entityType: ENTITY_TYPES
  disabled: boolean
  disableGrayBg?: boolean
  deleteServiceWarningMessage?: string
  loading: boolean
  localMode: boolean
  minimumServicesCount?: number
  onCheckboxChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void
  readOnly?: boolean
  serviceFrequencies: IServiceFrequency[]
  services: ILeadOppProduct[]
  totalServicesCount?: number
}

export function ServiceList(props: Props) {
  const { onCheckboxChange, services } = props

  return (
    <ServiceListCard elevation={0}>
      <>
        {services.map((service, index) => (
          <>
            <ServiceListCardContent direction="row" key={`${service.id}`}>
              <ServiceCheckbox
                label={`${service.name} - ${service.description}`}
                name="serviceIds"
                onChange={onCheckboxChange}
                value={service.id.toString()}
              />
            </ServiceListCardContent>
            {index < services.length - 1 && <Divider />}
          </>
        ))}
      </>
    </ServiceListCard>
  )
}
